'use strict';

const navbar = document.getElementById('navbar');
const ticker = document.getElementById('ticker');

function updateNavbar() {
  if (!navbar) return;
  const tickerH = ticker ? ticker.offsetHeight : 0;
  if (window.scrollY > tickerH + 10) {
    navbar.classList.add('scrolled');
  } else {
    navbar.classList.remove('scrolled');
  }
}
window.addEventListener('scroll', updateNavbar, { passive: true });
updateNavbar();

/* ── BURGER MENU ── */
const burger = document.getElementById('navBurger');
const navLinks = document.getElementById('navLinks');

if (burger && navLinks) {
  const setMobileMenu = isOpen => {
    navLinks.classList.toggle('open', isOpen);
    burger.classList.toggle('open', isOpen);
    navbar?.classList.toggle('menu-open', isOpen);
    document.body.classList.toggle('mobile-nav-open', isOpen);
    burger.setAttribute('aria-expanded', String(isOpen));
    burger.setAttribute('aria-label', isOpen ? 'Fermer le menu' : 'Ouvrir le menu');
    document.body.style.overflow = isOpen ? 'hidden' : '';

    if (isOpen) {
      document.getElementById('toast')?.classList.remove('show');
    }
  };

  window.closeMobileMenu = () => setMobileMenu(false);

  burger.addEventListener('click', () => {
    setMobileMenu(!navLinks.classList.contains('open'));
  });

  navLinks.querySelectorAll('.nav-link').forEach(link => {
    link.addEventListener('click', () => setMobileMenu(false));
  });

  navLinks.addEventListener('click', e => {
    if (e.target === navLinks) setMobileMenu(false);
  });

  document.addEventListener('click', e => {
    if (!navbar?.contains(e.target) && navLinks.classList.contains('open')) {
      setMobileMenu(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900 && navLinks.classList.contains('open')) {
      setMobileMenu(false);
    }
  });
}

/* ── SEARCH OVERLAY ── */
const searchOverlay = document.getElementById('searchOverlay');
const searchBtn = document.getElementById('searchBtn');
const searchInput = document.getElementById('searchInput');

function openSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => searchInput?.focus(), 100);
}

function closeSearch() {
  if (!searchOverlay) return;
  searchOverlay.classList.remove('open');
  document.body.style.overflow = '';
}
window.closeSearch = closeSearch;

searchBtn?.addEventListener('click', openSearch);
searchOverlay?.addEventListener('click', e => {
  if (e.target === searchOverlay) closeSearch();
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') {
    window.closeMobileMenu?.();
    closeSearch();
    closeCart();
  }
});

/* ── SCROLL REVEAL ── */
function initReveal() {
  const els = document.querySelectorAll('[data-reveal]');
  if (!els.length) return;

  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  els.forEach((el, i) => {
    el.classList.add('reveal');
    const delay = el.dataset.revealDelay;
    if (delay) el.classList.add(`reveal-d${delay}`);
    obs.observe(el);
  });
}

function formatMoney(cents) {
  const amount = (cents || 0) / 100;
  return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format(amount);
}

function renderCart(cart) {
  const itemsEl = document.getElementById('cdItems');
  const emptyEl = document.getElementById('cdEmpty');
  const footerEl = document.getElementById('cdFooter');
  const countEl = document.getElementById('cartCount');

  if (countEl) {
    countEl.textContent = cart.item_count;
    countEl.classList.toggle('visible', cart.item_count > 0);
  }

  if (!itemsEl) return;
  if (cart.item_count === 0) {
    itemsEl.innerHTML = `
      <div class="cd-empty" id="cdEmpty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="margin-bottom:1rem;opacity:0.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
        <p>Votre panier est vide.</p>
        <button type="button" class="btn btn-outline-dark" id="cdContinueEmpty" style="margin-top:1rem">Continuer mes achats</button>
      </div>`;
    if (footerEl) footerEl.style.display = 'none';
    document.getElementById('cdContinueEmpty')?.addEventListener('click', closeCart);
    return;
  }

  if (emptyEl) emptyEl.style.display = 'none';
  if (footerEl) footerEl.style.display = '';
  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cd-item" data-key="${item.key}">
      <div class="cd-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
      </div>
      <div class="cd-item-info cd-item-details">
        <div class="cd-item-header">
          <a class="cd-item-name cd-item-title" href="${item.url}">${item.product_title}</a>
          <button type="button" class="cd-item-rm cd-item-remove" data-key="${item.key}" aria-label="Supprimer">x</button>
        </div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cd-item-variant">${item.variant_title}</p>` : ''}
        <div class="cd-item-bottom">
          <div class="cd-item-qty cd-qty">
            <button type="button" class="cd-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Diminuer">-</button>
            <span class="cd-qty-val">${item.quantity}</span>
            <button type="button" class="cd-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Augmenter">+</button>
          </div>
          <div class="cd-item-price">${formatMoney(item.final_line_price)}</div>
        </div>
      </div>
    </div>`).join('');

  const subEl = document.getElementById('cdSubtotal');
  if (subEl) subEl.textContent = formatMoney(cart.total_price);
  bindCartDrawerControls();
}

async function fetchCart() {
  const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Cart request failed');
  return response.json();
}

async function changeCartItem(key, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  if (!response.ok) throw new Error('Cart update failed');
  renderCart(await response.json());
}

async function addFormToCart(form) {
  const submitters = [
    form.querySelector('[type="submit"]'),
    document.querySelector('[data-submit-product-form]')
  ].filter(Boolean);
  submitters.forEach(btn => {
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
  });
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: new FormData(form)
  });
  try {
    if (!response.ok) throw new Error('Add to cart failed');
    const item = await response.json();
    renderCart(await fetchCart());
    openCart();
    showToast(`${item.product_title || 'Produit'} ajouté au panier`);
  } finally {
    submitters.forEach(btn => {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }
}

function bindCartDrawerControls() {
  document.querySelectorAll('[data-key][data-qty]').forEach(btn => {
    btn.addEventListener('click', () => changeCartItem(btn.dataset.key, Number(btn.dataset.qty)));
  });
  document.querySelectorAll('.cd-item-remove[data-key]').forEach(btn => {
    btn.addEventListener('click', () => changeCartItem(btn.dataset.key, 0));
  });
}

function bindCartButtons() {
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      try {
        await addFormToCart(form);
      } catch {
        form.submit();
      }
    });
  });
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', e => {
      const form = btn.closest('form');
      if (!form) return;
      e.preventDefault();
      form.requestSubmit();
    });
  });
}

async function refreshCart() {
  try {
    renderCart(await fetchCart());
  } catch {
    // Shopify will still process normal form submissions if Ajax is unavailable.
  }
}

function openCart() {
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('open');
  document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.getElementById('cartDrawer')?.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
window.closeCart = closeCart;
window.openCart = openCart;

/* ── TOAST ── */
let toastTimer;
function showToast(msg) {
  const el = document.getElementById('toast');
  const txt = document.getElementById('toastText');
  if (!el || !txt) return;
  txt.textContent = msg;
  el.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), 3200);
}
window.showToast = showToast;

/* ── SMOOTH SCROLL ── */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const offset = (navbar?.offsetHeight || 72) + 16;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth'
        });
      }
    });
  });
}

/* ── PARALLAX ── */
function initParallax() {
  const heroBackgrounds = [...document.querySelectorAll('[data-parallax]')];
  const brandSections = [...document.querySelectorAll('[data-brand-parallax-section]')];
  if (!heroBackgrounds.length && !brandSections.length) return;

  const motionAllowed = window.matchMedia('(min-width: 901px) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let frameId = 0;

  const reset = () => {
    heroBackgrounds.forEach(element => element.style.removeProperty('transform'));
    brandSections.forEach(section => {
      section.querySelectorAll('[data-brand-parallax]').forEach(element => {
        element.style.removeProperty('--brand-parallax-y');
      });
    });
  };

  const update = () => {
    frameId = 0;
    if (!motionAllowed.matches) {
      reset();
      return;
    }

    const viewportHeight = window.innerHeight;

    heroBackgrounds.forEach(element => {
      const container = element.closest('.hero') || element.parentElement;
      const rect = container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const shift = Math.min(90, Math.max(-30, -rect.top * .18));
      element.style.transform = `scale(1.05) translate3d(0, ${shift}px, 0)`;
    });

    brandSections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const progress = Math.max(-1, Math.min(1, (viewportHeight * .5 - (rect.top + rect.height * .5)) / viewportHeight));

      section.querySelectorAll('[data-brand-parallax]').forEach(element => {
        const distance = Number(element.dataset.brandParallax || 0);
        element.style.setProperty('--brand-parallax-y', `${(progress * distance).toFixed(2)}px`);
      });
    });
  };

  const requestUpdate = () => {
    if (frameId) return;
    frameId = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  motionAllowed.addEventListener?.('change', requestUpdate);
  requestUpdate();
}

function initProductInteractions() {
  document.querySelectorAll('.qty-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input, .qty-val');
    selector.querySelector('.qty-btn.minus')?.addEventListener('click', () => {
      if (!input) return;
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    selector.querySelector('.qty-btn.plus')?.addEventListener('click', () => {
      if (!input) return;
      input.value = Number(input.value || 1) + 1;
    });
  });

  const mainMedia = document.querySelector('.media-main, .main-media');
  document.querySelectorAll('.thumb-item, .thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mediaType = thumb.dataset.mediaType || 'image';
      const mediaSrc = thumb.dataset.mediaSrc;
      if (mainMedia && mediaSrc) {
        if (mediaType === 'video') {
          mainMedia.innerHTML = `<video src="${mediaSrc}" autoplay loop muted playsinline preload="metadata"></video>`;
          const video = mainMedia.querySelector('video');
          if (video) {
            video.muted = true;
            video.play().catch(() => {});
          }
        } else {
          mainMedia.innerHTML = `<img src="${mediaSrc}" alt="" loading="eager">`;
        }
      } else {
        const img = thumb.querySelector('img');
        const activeImg = mainMedia?.querySelector('img.media-item, img');
        if (!img || !activeImg) return;
        activeImg.src = img.src.replace(/width=150/, 'width=1000');
      }
      document.querySelectorAll('.thumb-item, .thumb').forEach(item => item.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  document.querySelectorAll('.accordion-trigger, .detail-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item, .detail-item');
      if (!item) return;
      const isDetail = item.classList.contains('detail-item');
      const isOpen = isDetail ? item.classList.toggle('active') : item.classList.toggle('open');
      trigger.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const productPrice = document.getElementById('productPrice');
  const productComparePrice = document.getElementById('productComparePrice');
  const productPromoSeal = document.getElementById('productPromoSeal');
  const stickyProductPrice = document.getElementById('stickyProductPrice');

  document.querySelectorAll('.variant-opt input[type="radio"]').forEach(input => {
    input.addEventListener('change', () => {
      document.querySelectorAll('.variant-opt').forEach(label => label.classList.remove('active'));
      input.closest('.variant-opt')?.classList.add('active');

      const price = Number(input.dataset.price || 0);
      const compareAtPrice = Number(input.dataset.compareAtPrice || 0);
      const promoPercent = Number(input.dataset.promoPercent || 0);
      const isPromotion = compareAtPrice > price && promoPercent > 0;

      if (productPrice) {
        productPrice.textContent = input.dataset.priceFormatted || '';
        productPrice.classList.toggle('product-price-main--sale', isPromotion);
      }
      if (stickyProductPrice) {
        stickyProductPrice.textContent = input.dataset.priceFormatted || '';
      }
      if (productComparePrice) {
        productComparePrice.textContent = input.dataset.compareAtPriceFormatted || '';
        productComparePrice.hidden = !isPromotion;
      }
      if (productPromoSeal) {
        const percentLabel = productPromoSeal.querySelector('[data-promo-percent]');
        if (percentLabel) percentLabel.textContent = `-${promoPercent}%`;
        productPromoSeal.hidden = !isPromotion;
      }
    });
  });

  document.querySelectorAll('[data-submit-product-form]').forEach(btn => {
    btn.addEventListener('click', () => {
      const form = document.getElementById('add-to-cart-form') || document.querySelector('form[action*="/cart/add"]');
      form?.requestSubmit();
    });
  });

  const stickyBar = document.querySelector('[data-sticky-product-bar]');
  const productActions = document.querySelector('.product-actions');
  if (stickyBar && productActions) {
    const obs = new IntersectionObserver(entries => {
      const entry = entries[0];
      stickyBar.classList.toggle('visible', !entry.isIntersecting && window.scrollY > 280);
    }, { threshold: 0.2 });
    obs.observe(productActions);
  }
}

function initRoutineTabs() {
  const wrappers = document.querySelectorAll('[data-routine-tabs]');
  wrappers.forEach(wrapper => {
    const section = wrapper.closest('.routine-comparison');
    const tabs = wrapper.querySelectorAll('[data-routine-tab]');
    const cards = section?.querySelectorAll('[data-routine-card]');
    if (!section || !tabs.length || !cards?.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.routineTab;
        tabs.forEach(item => {
          const active = item === tab;
          item.classList.toggle('active', active);
          item.setAttribute('aria-selected', String(active));
        });
        cards.forEach(card => card.classList.toggle('active', card.dataset.routineCard === id));
      });
    });
  });
}

function initHairDiagnostic() {
  document.querySelectorAll('[data-diagnostic]').forEach(app => {
    const options = app.querySelectorAll('[data-diagnostic-option]');
    const results = app.querySelectorAll('[data-diagnostic-result]');
    options.forEach(option => {
      option.addEventListener('click', () => {
        const id = option.dataset.diagnosticOption;
        options.forEach(item => item.classList.toggle('active', item === option));
        results.forEach(result => result.classList.toggle('active', result.dataset.diagnosticResult === id));
      });
    });
  });
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();
  bindCartButtons();
  bindCartDrawerControls();
  initReveal();
  initSmoothScroll();
  initParallax();
  initProductInteractions();
  initRoutineTabs();
  initHairDiagnostic();

  /* Cart triggers */
  document.getElementById('cartTrigger')?.addEventListener('click', openCart);
  document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
  document.getElementById('cdClose')?.addEventListener('click', closeCart);
  document.getElementById('cdContinue')?.addEventListener('click', closeCart);
  document.getElementById('cdContinueEmpty')?.addEventListener('click', closeCart);
});
